import { Lock } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LockIcon = createLucideIcon(Lock);
